import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import en from 'vuetify/lib/locale/en';
import es from 'vuetify/lib/locale/es';

Vue.use(Vuetify);

function initialVuetifyLang() {
    try {
        return localStorage.getItem('builder_locale') === 'en' ? 'en' : 'es';
    } catch (e) {
        return 'es';
    }
}

function initialThemeDark() {
    try {
        const saved = localStorage.getItem('builder_theme');
        if (saved === 'dark') return true;
        if (saved === 'light') return false;
        return false; // sin setear: light (tema anterior)
    } catch (e) {
        return false;
    }
}

const accents = {
    primary: '#CCFF33',
    secondary: '#66CCCC',
    accent: '#339999',
    error: '#E85C5C',
    info: '#66CCCC',
    success: '#009966',
    warning: '#CCFF33',
    star: '#F5A623',
    backGroundPrimary: '#333333',
    backGroundSecondary: '#666666',
};

export default new Vuetify({
    iconfont: 'mdi',
    lang: {
        locales: { en, es },
        current: initialVuetifyLang(),
    },
    theme: {
        dark: initialThemeDark(),
        options: {
            customProperties: true,
        },
        themes: {
            light: {
                ...accents,
                bg: '#F4F6F9',
                surface: '#FFFFFF',
                surface2: '#F0F2F5',
                field: '#F7F9FC',
                outline: '#E2E8F0',
                outline2: '#CBD5E0',
                sidebar: '#090B0F',
                txtPrimary: '#0F1623',
                txtSecondary: '#4A5568',
                txtMuted: '#A0AEC0',
            },
            dark: {
                ...accents,
                bg: '#080A0E',
                surface: '#111520',
                surface2: '#1C2233',
                field: '#1C2233',
                outline: '#2A3450',
                outline2: '#364060',
                sidebar: '#06080C',
                txtPrimary: '#F2F5FA',
                txtSecondary: '#9AAAC0',
                txtMuted: '#556070',
            },
        },
    },
    icons: {
        values: {
            account: {component: () => import('@/components/icons/account')},
            account_circle: {component: () => import('@/components/icons/account_circle')},
            account_multiple: {component: () => import('@/components/icons/account_multiple')},
            calendar: {component: () => import('@/components/icons/calendar')},
            home: {component: () => import('@/components/icons/home')},
            statistics: {component: () => import('@/components/icons/statistics')},
            logout: {component: () => import('@/components/icons/logout')},
            add_circle: {component: () => import('@/components/icons/add_circle')},
            copy: {component: () => import('@/components/icons/copy')},
            edit: {component: () => import('@/components/icons/edit')},
            save: {component: () => import('@/components/icons/save')},
            training: {component: () => import('@/components/icons/training')},
            left_arrow: {component: () => import('@/components/icons/left_arrow')},
            right_arrow: {component: () => import('@/components/icons/right_arrow')},
            dots_vertical: {component: () => import('@/components/icons/dots_vertical')},
            lock: {component: () => import('@/components/icons/lock')},
            delete: {component: () => import('@/components/icons/delete')},
            vacations: {component: () => import('@/components/icons/vacations')},
            injury: {component: () => import('@/components/icons/injury')},
            company: {component: () => import('@/components/icons/company')},
            search: {component: () => import('@/components/icons/search')},
            check: {component: () => import('@/components/icons/check')},
            close: {component: () => import('@/components/icons/close')},
            upload_image: {component: () => import('@/components/icons/upload_image')},
            strong: {component: () => import('@/components/icons/strong')},
            speed: {component: () => import('@/components/icons/speed')},
            mobility: {component: () => import('@/components/icons/mobility')},
            stability: {component: () => import('@/components/icons/stability')},
            resistance: {component: () => import('@/components/icons/resistance')},
            hypertrophy: {component: () => import('@/components/icons/hypertrophy')},
            power: {component: () => import('@/components/icons/power')},
            circuit: {component: () => import('@/components/icons/circuit')},
            myofascial_relaxation: {component: () => import('@/components/icons/myofascial_relaxation')},
            activity: {component: () => import('@/components/icons/activity')},
            stability2: {component: () => import('@/components/icons/stability2')},
            painScale: {component: () => import('@/components/icons/painScale')},
            add_routine: {component: () => import('@/components/icons/add_routine')},
            add_program: {component: () => import('@/components/icons/add_program')},
            add_prescription: {component: () => import('@/components/icons/add_prescription')},
            add_circuit: {component: () => import('@/components/icons/add_circuit')},
            add_questionnaire: {component: () => import('@/components/icons/add_questionnaire')},
            reload_energy: {component: () => import('@/components/icons/reload_energy')},
            bad_face: {component: () => import('@/components/icons/bad_face')},
            mental_energy: {component: () => import('@/components/icons/mental_energy')},
            sleep: {component: () => import('@/components/icons/sleep')},
            battery: {component: () => import('@/components/icons/battery')},
        }
    }
});
